<div class="inner-content">
    <div class="password-change">

        <div class="top-wrapper">
            <img src="assets/icon-user-profile.svg" alt="">
            <p class="name">
                {{ user?.name | default }}
            </p>
            <p class="email">
                {{ user?.email | default }}
            </p>

        </div>


        <form (ngSubmit)="onSubmit()" [formGroup]="form">

            <h2>
                Edytuj profil
            </h2>
            <div class="input-container">
                <cmn-label class="dark">
                    <input type="text"
                      formControlName="phone"
                      autocomplete="off"
                      placeholder="Podaj numer telefonu"
                      kendoTextBox/>
                    <cmn-errors [control]="form.get('phone')"></cmn-errors>
                </cmn-label>
            </div>

            <button type="submit"
                    kendoButton
                    [primary]="true"
                    class="big"
            >
                Zapisz ustawienia
            </button>

        </form>
    </div>
</div>

<ns-fixed-element position="top">
    <div class="mobile-floater">
        <a routerLink="/">
            Powrót
        </a>
    </div>
</ns-fixed-element>
